import styles from '@ui/components/Pill/Pill.module.scss';
import FontAwesomeProIcon from '@ui/components/FontAwesomeProIcon/FontAwesomeProIcon';
import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import { Button } from '@ariakit/react';

const Pill = ({
  children,
  variant = null,
  className = null,
  isActive = false,
  onClick,
  glyph = null,
  ...props
}) => (
  <Button
    {...props}
    className={classNames(
      styles.container,
      {
        [styles[variant]]: variant,
        [styles.active]: isActive,
      },
      className,
    )}
    onClick={onClick || function () {}}
  >
    {children}
    {glyph && (
      <span className={styles.iconWrapper}>
        <FontAwesomeProIcon
          aria-label="löschen"
          className={styles.icon}
          fixedWidth
          icon={glyph}
        />
      </span>
    )}
  </Button>
);

Pill.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  glyph: PropTypes.string,
  isActive: PropTypes.bool,
  onClick: PropTypes.func,
  variant: PropTypes.oneOf(['tag', 'outlined']),
};

export default Pill;
